import type { SessionPlatformName } from '@fluxus/shared';

const BROWSERS: [RegExp, string][] = [
  [/Edg(A|iOS)?\//, 'Edge'],
  [/OPR\/|Opera/, 'Opera'],
  [/SamsungBrowser\//, 'Samsung Internet'],
  [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];

const SYSTEMS: [RegExp, string][] = [
  [/Android/, 'Android'],
  [/iPhone|iPad|iPod/, 'iOS'],
  [/Windows/, 'Windows'],
  [/Mac OS X|Macintosh/, 'macOS'],
  [/CrOS/, 'ChromeOS'],
  [/Linux/, 'Linux'],
];

const match = (ua: string, table: [RegExp, string][]) => table.find(([re]) => re.test(ua))?.[1] ?? null;

/** Nome legível do aparelho de uma sessão ("Chrome no Windows", "App Android"). */
export function describeDevice(platform: SessionPlatformName, userAgent: string | null): string {
  const ua = userAgent ?? '';
  const system = match(ua, SYSTEMS);
  if (platform === 'DESKTOP') return system ? `App desktop no ${system}` : 'App desktop';
  if (platform === 'ANDROID') return 'App Android';
  if (platform === 'IOS') return 'App iOS';
  const browser = match(ua, BROWSERS);
  if (browser && system) return `${browser} no ${system}`;
  return browser ?? (system ? `Navegador no ${system}` : 'Navegador');
}
